import React from "react";

import ShapeCard from "./shape-card";
import { type ShapeItem } from "./shape-item.types";

interface SectionShapesProps {
  shapes: ShapeItem[];
}

const SectionShapes: React.FC<SectionShapesProps> = ({
  shapes,
}) => {
  return (
    <div className="mt-2 flex w-full flex-col gap-2">
      {shapes.map((shape) => (
        <ShapeCard
          key={shape.id}
          boundaryId={shape.boundaryId}
          customLayerId={shape.customLayerId}
          label={shape.label}
          mapLevelId={shape.mapLevelId}
          note={shape.note}
          previewColor={shape.previewColor}
          previewCoordinates={shape.previewCoordinates}
          schoolDriveId={shape.schoolDriveId}
          schoolId={shape.schoolId}
          value={shape.value}
          onRemove={shape.onRemove}
        />
      ))}
    </div>
  );
};

export default SectionShapes;